<template>
    <div>
          <v-container fluid>
                      <v-row>
                          <v-col cols="12" v-for="(com) in datosObjCom" :key="com.id">
                              <v-card elevation="10">
                              <v-card-title>
                                  {{com.nombre}}
                                  <v-spacer></v-spacer>
                                  {{(com.asignado>0) ? 'Asignación Institucional' :  ''}}
                              </v-card-title>
                              <v-card-text>
                                <v-row>
                                <v-col cols="8">
                                  <v-row>
                                    <v-col cols="12">
                                      <b>Descripción:</b> {{com.descripcion}}
                                    </v-col>
                                    <v-col cols="12">
                                      <b>Resultados:</b> {{com.resultados}}
                                    </v-col>
                                    <v-col cols="12">
                                      <b>Caso Éxito:</b> {{com.casoexito}}
                                    </v-col>
                                    <v-col cols="2">
                                      <b>Peso:</b> {{com.peso}}%
                                    </v-col>
                                    <v-col cols="3">
                                      <b>Inicia:</b> {{com.fecinicio}}
                                    </v-col>
                                    <v-col cols="3">
                                      <b>Finaliza:</b> {{com.fecfin}}
                                    </v-col>
                                    <v-col cols="4">
                                      <b>Estado:</b> {{com.dstatus}}
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="4">
                                  <div class="content scrollable" ref="xyz">
                                      <div style="padding:4px; font-size: 10px;" v-for="come in com.comentario" :key="come.id">
                                        <div style="text-align: left;" v-if="come.alias=='Colaborador'">
                                          <v-avatar size="30">
                                            <img :src="(come.imagen_usuario) ? come.imagen_usuario : come.colaborador[0].imagen_usuario" alt="Imagen del Colaborador">
                                          </v-avatar>
                                         <b> {{come.alias}}</b>: {{come.nombre}} <br><b>{{come.etapaname}}</b> {{come.fecha}} <br>{{come.comentario}}
                                        </div>
                                        <div style="text-align: right;" v-else>
                                          <b>{{come.alias}}</b>: {{come.nombre}}
                                          <v-avatar size="30">
                                            <img :src="(come.imagen_usuario) ? come.imagen_usuario : come.colaborador[0].imagen_usuario" alt="Imagen del Colaborador">
                                          </v-avatar>
                                         <br><b>{{come.etapaname}}</b> {{come.fecha}} <br>{{come.comentario}}
                                        </div>
                                      </div>
                                  </div>
                                  <v-row v-if="comAct">
                                    <v-col cols="11">
                                      <v-textarea @change="signalChange" :value="valor" outlined label="Comentarios" rows="1"></v-textarea>
                                    </v-col>
                                    <v-col cols="1" class="d-flex justify-center">
                                      <v-icon @click="newCom(com)">mdi-arrow-right-drop-circle-outline</v-icon>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="6" v-if="calificacioncol">
                                  <v-card>
                                    <v-card-title>
                                      Evaluación Colaborador
                                    </v-card-title>
                                    <v-card-text>
                                      <!-- <div v-if="com.calificacionmed_col == 0 && medioano && colaborador"> -->
                                      <div v-if="medioano && colaborador">
                                        <v-select :items="escala" v-model="com.puntocol" @change="puntuar('calificacionmed_col',com)" :label="'Evaluacion Medio Año de ' + com.nombre" outlined></v-select>
                                      </div>
                                      <div v-if="com.calificacionmed_col > 0 && medioano">
                                        <p>Evaluación Medio Año: {{com.calificacionmed_col}}</p>
                                      </div>
                                      <!-- <div v-if="com.calificacionfin_col == 0 && finano && colaborador"> -->
                                      <div v-if="finano && colaborador">  
                                        <v-select :items="escala" v-model="com.puntocol" @change="puntuar('calificacionfin_col',com)" :label="'Evaluacion Final de ' + com.nombre" outlined></v-select>
                                      </div>
                                      <div v-if="com.calificacionfin_col > 0 && finano">
                                        Evaluación Final: {{com.calificacionfin_col}}
                                      </div>                                      
                                    </v-card-text>
                                  </v-card>                                  
                                </v-col>
                                <v-col cols="6" v-if="calificacionsup">
                                  <v-card>
                                    <v-card-title>
                                      Evaluación Supervisor
                                    </v-card-title>
                                    <v-card-text>
                                      <!-- <div v-if="com.calificacionmed_sup == 0 && medioano && supervisor"> -->
                                      <div v-if="medioano && supervisor">  
                                        <v-select :items="escala" v-model="com.puntosup"  @change="puntuar('calificacionmed_sup',com)" :label="'Evaluacion Medio Año de' + com.nombre" outlined></v-select>
                                      </div>
                                      <div v-if="com.calificacionmed_sup > 0 && medioano">
                                        <p>Evaluación Medio Año: {{com.calificacionmed_sup}}</p>
                                      </div>
                                      <!-- <div v-if="com.calificacionfin_sup == 0 && finano && supervisor"> -->
                                      <div v-if="finano && supervisor">  
                                        <v-select :items="escala" v-model="com.puntosup"  @change="puntuar('calificacionfin_sup',com)" :label="'Evaluacion Final de ' + com.nombre" outlined></v-select>
                                      </div>
                                      <div v-if="com.calificacionfin_sup > 0 && finano">
                                        Evaluación Final: {{com.calificacionfin_sup}}
                                      </div>                                      
                                    </v-card-text>
                                  </v-card>                                  
                                </v-col>                         
                                </v-row>
                              </v-card-text>
                              
                                <v-card-actions v-if="editable">
                                  <v-icon small @click="editItem(com)" v-if="com.asignado==0">mdi-pencil</v-icon>
                                  <v-spacer></v-spacer>
                                  <v-icon small @click="deleteItem(com)" v-if="com.asignado==0">mdi-delete</v-icon>
                                </v-card-actions>
                              </v-card>
                          </v-col>
                      </v-row>
                  </v-container>
    </div>
</template>

<script>

export default {
    props: {
        datosObjCom: {type: Array, default: null},
        escala: {type: Array, default: null},
        editable: {type: Boolean, default: false},
        comAct: {type: Boolean, default: true},
        calificacioncol: {type: Boolean, default: false},
        calificacionsup: {type: Boolean, default: false},
        medioano: {type: Boolean, default: false},
        finano: {type: Boolean, default: false},
        colaborador: {type: Boolean,default: false},
        supervisor: {type: Boolean,default: false},
    },
    data() {
        return {
            nuevoCom: '', valor: '',
        }
    },
    methods: {
        newCom(com){
            com.nuevoCom = this.nuevoCom
            this.$emit('newCom',com)
            this.nuevoCom = ''
            if(this.valor == ''){
              this.valor = null
            }else{
              this.valor = ''
            }
        },
        editItem(com){
            this.$emit('editItem',com)
        },
        puntuar(tipo,com){
          // if(tipo=='calificacionmed_col')
          //   com.calificacionmed_col = com.puntocol
          // if(tipo=='calificacionmed_sup')
          //   com.calificacionmed_sup = com.puntosup
          com.calificoA = tipo
          this.$emit('puntuar',com)
        },        
        deleteItem(com){
            this.$emit('deleteItem',com)
        },
        signalChange(evt){
          this.nuevoCom = evt
        },
        scrollAbajo(){
            let messageDisplay = this.$refs.xyz
            if(messageDisplay){
              for(let i = 0; i < messageDisplay.length; i++){
                messageDisplay[i].scrollTop = messageDisplay[i].scrollHeight
              }
            }
        },
    },
    updated() {
      this.scrollAbajo()
    },
    mounted() {
      let messageDisplay = this.$refs.xyz
        if(messageDisplay){
          for(let i = 0; i < messageDisplay.length; i++){
            messageDisplay[i].scrollTop = messageDisplay[i].scrollHeight
          }
        }
    },
}
</script>
<style scoped>
.scrollable {
  height: 100px; 
  overflow-y: scroll;
}
</style>